import { getStores } from '../services';
export const fetchStores = () => getStores().then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    const formattedData = Object.entries(response?.data)?.map(([value, label]) => ({
        value,
        label: label + ' - ' + value,
    }));
    return { data: formattedData };
};
